<template>
    <div class="modal fade" id="modalChangeEps" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        <i class="fas fa-sync fa-fw"></i> Cambiar Eps - Historia Clinica No. {{ historia_clinica.id }}
                    </h5>
                    <div class="d-flex justify-content-end mx-2">
                        <span class="badge badge-secondary-soft badge-marketing" v-if="historia_clinica.tipo_historia"> {{
                            historia_clinica.tipo_historia.nombre }}</span>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <div class="justify-content-between mx-2 font-weight-bolder" v-if="historia_clinica.user">
                            <i class="fa fa-user fa-fw"></i> {{ historia_clinica.user.name }}
                        </div>
                        <div class="justify-content-end mx-2 font-weight-bolder">
                            <i class="fa fa-calendar fa-fw"></i> {{ historia_clinica.fecha | formatDate }}
                        </div>
                    </div>
                    <div class="mt-2">
                        <small class="font-italic" v-if="historia_clinica.eps"><i class="fas fa-hospital-alt fa-fw"></i>
                            {{ historia_clinica.eps.DESEPS }}
                        </small>
                    </div>
                    <div class="form-group mt-2">
                        <label class="small mb-1 font-weight-bolder">EPS <small>(*)</small></label>
                        <v-select-eps mode="object" v-model="eps"
                        :class="{
                            'is-invalid' : $v.eps.$error && $v.eps.$dirty
                        }"></v-select-eps>
                        <span class="invalid-feedback" v-if="!$v.eps.required">
                            Este campo es requerido
                        </span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success btn-sm" @click="guardar();">Guardar <i
                            class="fa fa-save fa-fw"></i></button>
                    <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">Cerrar <i
                            class="fa fa-times-circle fa-fw"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import historiaClinicaService from "../../../services/historiaClinicaService";
import $ from 'jquery';
import Toast from '../../../components/common/utilities/toast';
import { required } from "vuelidate/lib/validators";
import VSelectEps from "../../../components/common/VSelectEps";

export default {
    components:{VSelectEps},
    data() {
        return {
            eps: '',
            historia_clinica: {}
        }
    },
    validations() {
        return {
            eps:{ required}
        }
    },
    methods: {
        async guardar() {
            try {

                this.$v.$touch();

                if (this.$v.$invalid) return;

                this.LoaderSpinnerShow();
                await historiaClinicaService.changeEps({
                    id_eps:this.eps.id,
                    id_historia:this.historia_clinica.id
                });
                this.LoaderSpinnerHide();
                this.limpiarCampos();

                $(`#modalChangeEps`).modal('hide');

                this.$emit('cambio-eps');

                Toast.fire({
                    icon: 'success',
                    title: 'Historia Ha sido abierta con exito'
                });


            } catch (error) {
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        limpiarCampos() {
            this.eps = '';
        },
        openModal(historia) {
            this.$nextTick(async () => {
                $('#modalChangeEps').modal('show');
                this.historia_clinica = historia;
            });
        },
    },
}
</script>
